import React from 'react'
import './careers.css'


import CareersHeader from '../careers/CareersHeader';
import CareersBody from '../careers/CareersBody';
import Footer2 from "../footer2/Footer2";

function Careers() {
  return (
    <section>
         <CareersHeader/>
          <CareersBody/> 
          <Footer2/>
    </section>
  )
}

export default Careers
